<div class="page-not-found-container">
  <div class="page-not-found-header">
    <fa-icon [icon]="locationQuestionIcon"></fa-icon>
    <h1 class="page-not-found-title">Page not found</h1>
  </div>
  <p class="page-not-found-message">The page you're looking for does not exist at this address.</p>
  @if (hasHomeAccess()) {
  <button type="button" class="btn btn-primary" (click)="redirectToHome()">Go to Home</button>
  }
</div>
